import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const UserDetailsPopup = ({ open, onClose, userData }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          backgroundColor: "var(--paper-color)",
          color: "var(--text-primary-color)",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle
        style={{
          background: "var(--primary-color)",
          color: "var(--text-primary-color)",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        User Details
      </DialogTitle>
      <DialogContent
        style={{
        //   backgroundColor: "var(--background-color)",
          color: "var(--text-secondary-color)",
          padding: "20px",
        }}
      >
        <div style={{ lineHeight: "1.8", fontSize: "1rem" }}>
          <p>
            <strong>Username:</strong> {userData.userName}
          </p>
          <p>
            <strong>First Name:</strong> {userData.firstName}
          </p>
          <p>
            <strong>Last Name:</strong> {userData.lastName}
          </p>
          <p>
            <strong>Email:</strong> {userData.email}
          </p>
          <p>
            <strong>Display Name:</strong> {userData.displayName}
          </p>
          <p>
            <strong>Admin Roles:</strong> {userData.adminRoles?.join(", ")}
          </p>
        </div>
      </DialogContent>
      <DialogActions
        style={{
        backgroundColor: "var(--background-color)",
        //   justifyContent: "center",
          padding: "10px",
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDetailsPopup;
